import {
  microsoftAuthApiRef,
  SignInPageProps,
} from '@backstage/core-plugin-api';
import Typography from '@mui/material/Typography';
import { SignInPage } from './SignInPage';

export const SynechronSignInPage = (props: SignInPageProps) => {
  return (
    <SignInPage
      providers={[
        {
          id: 'microsoft-auth-provider',
          title: 'Microsoft Entra',
          subheading: 'Enter through your Microsoft Entra Account',
          message: (
            <Typography>
              You will have access based on the Microsoft Entra account created
              via Synechron.
            </Typography>
          ),
          apiRef: microsoftAuthApiRef,
        },
      ]}
      {...props}
    />
  );
};
